module.exports = __webpack_public_path__ + "static/media/farmindia_img_client_1.9f0a82f6.svg";